import { defineMessages } from 'react-intl';

export const bodyMessages = defineMessages({
  errorInfo: {
    defaultMessage: 'Try again',
    id: 'CfPDLS',
    description: 'Title for the error message when there is an error fetching the advanced shipping notice',
  },
  tryAgain: {
    defaultMessage: 'There was an error fetching your advanced shipping notice',
    id: '3rzr0v',
    description: 'Error message when there is an error fetching the advanced shipping notice',
  },
});
